/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_Select_LabelInputs */

const vi_carrier_legacy_select_label = /** @type {(inputs: Carrier_Legacy_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xã in trên tem`)
};

/**

* @param {Carrier_Legacy_Select_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_select_label = /** @type {((inputs?: Carrier_Legacy_Select_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Select_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_select_label(inputs)
});